import React from "react";
import { Helmet } from "react-helmet";
import ContactCard from "../components/Main/Contact/ContactCard/ContactCard";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact - We Want to Hear From You</title>
        <meta
          name="description"
          content="We are always excited to hear from our esteemed customers. Contact us to kick-start your new project."
        />
      </Helmet>
      <main>
        <ContactCard />
      </main>
    </>
  );
};

export default Contact;
